var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 3.6129 12.3871 0 8 0C3.58065 0 0 3.6129 0 8C0 12.4194 3.58065 16 8 16C12.3871 16 16 12.4194 16 8ZM8 9.6129C8.80645 9.6129 9.48387 10.2903 9.48387 11.0968C9.48387 11.9355 8.80645 12.5806 8 12.5806C7.16129 12.5806 6.51613 11.9355 6.51613 11.0968C6.51613 10.2903 7.16129 9.6129 8 9.6129ZM6.58065 4.29032C6.54839 4.06452 6.74194 3.87097 6.96774 3.87097H9C9.22581 3.87097 9.41935 4.06452 9.3871 4.29032L9.16129 8.67742C9.12903 8.90323 8.96774 9.03226 8.77419 9.03226H7.19355C7 9.03226 6.83871 8.90323 6.80645 8.67742L6.58065 4.29032Z",
    fill: "#39556B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportant);
export default __webpack_public_path__ + "static/media/Important.d3da1d7f494055840998758d60ae0e70.svg";
export { ForwardRef as ReactComponent };